import { SortDescriptor } from "react-aria-components";

import { ModuleVersionExampleRow } from "./types";

export const sortModuleVersionExamples = (
  examples: ModuleVersionExampleRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return examples;
  }

  const direction = sortDescriptor.direction === "ascending" ? 1 : -1;

  return [...examples].sort(
    (a, b) => a.id.localeCompare(b.id, undefined, { numeric: true }) * direction
  );
};
